import { authModalIds } from 'root/src/shared/auth/auth.constants';
import { useQueryParam } from 'use-query-params';
import { useEffect, useMemo } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { SwitchToCreatorPlatformLauncher } from 'root/src/client/v2/auth/components/SwitchToCreatorPlatformModal';
const QUERY_MODULES = {
    [authModalIds.SWITCH_TO_CREATOR_PLATFORM_MODAL]: {
        content: SwitchToCreatorPlatformLauncher,
        renderAsComponent: true,
    },
};
export const MountQueryModalLauncher = () => {
    const modal = useModal();
    const { modalProps, module, clearSearchParams } = useModalQueryContext();
    useEffect(() => {
        if (!module) {
            return;
        }
        if (module.renderAsComponent) {
            return;
        }
        const ModalModule = module.content;
        modal.show(<ModalModule {...modalProps}/>, { onClose: clearSearchParams });
    }, [module, modalProps]);
    if (module === null || module === void 0 ? void 0 : module.renderAsComponent) {
        const ModalModule = module.content;
        return (<ModalModule />);
    }
    return null;
};
const isObject = (value) => value && typeof value === 'object' && value.constructor === Object;
export const useModalQueryContext = () => {
    const [modalId] = useQueryParam('modal');
    const [modalPropsString] = useQueryParam('modal_props');
    const modalProps = useMemo(() => {
        try {
            const parsedProps = JSON.parse(modalPropsString);
            if (!isObject(parsedProps)) {
                return {};
            }
            return parsedProps;
        }
        catch (e) {
            return {};
        }
    }, [modalPropsString]);
    const clearSearchParams = () => {
        const url = new URL(window.location.href);
        if (url.searchParams.has('modal')) {
            url.searchParams.delete('modal');
            url.searchParams.delete('modal_props');
            window.history.replaceState({}, '', url.toString());
        }
    };
    const module = QUERY_MODULES[modalId];
    return {
        modalProps: modalProps,
        clearSearchParams,
        module,
    };
};
